/*
 * The gallery thumbnail (F-MCK-013): the v3 generic mockup wireframe (`.th`), a 16:10 tile that
 * fills its card. Mockup `--surface` is `--surface-raised`, `--surface-2` is `--surface-sunken` and
 * `--text-2` is `--text-muted`, so the tile follows the light and the dark theme. `--pc` is the
 * project's primary, set by the component; before generation it is the neutral `--text-subtle`.
 */
.thumbnail {
  --pc: var(--text-subtle);

  position: relative;
  display: grid;
  grid-template-columns: 22% 1fr;
  grid-template-rows: 14% 1fr;
  gap: 6px;
  box-sizing: border-box;
  inline-size: 100%;
  block-size: 100%;
  padding: 10px;
  overflow: hidden;
  background: var(--surface-sunken);
}

/*
 * The tinted parts mix the project colour toward the theme surface (v3), and carry the theme's
 * hairline so a very dark brand colour stays visible on the dark surface (orchestrator decision).
 */
.top {
  grid-column: 1 / -1;
  box-sizing: border-box;
  border: 1px solid var(--border);
  border-radius: 3px;
  background: color-mix(in srgb, var(--pc) 20%, var(--surface-raised));
}

.side {
  border-radius: 3px;
  background: var(--surface-raised);
}

.main {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-block-size: 0;
}

/* v3 draws `var(--pc)` at `opacity: .85` over the tile: the same colour, mixed. */
.block {
  box-sizing: border-box;
  block-size: 22%;
  border: 1px solid var(--border);
  border-radius: 3px;
  background: color-mix(in srgb, var(--pc) 85%, var(--surface-sunken));
}

.columns {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6px;
}

.column {
  border-radius: 3px;
  background: var(--surface-raised);
}

/* The name, always on screen: one line, cut with an ellipsis inside the tile's padding. */
.name {
  position: absolute;
  inset-inline-start: 10px;
  inset-block-end: 8px;
  box-sizing: border-box;
  max-inline-size: calc(100% - 20px);
  padding: 0 6px;
  overflow: hidden;
  border-radius: var(--radius-small);
  background: var(--surface-raised);
  color: var(--text-muted);
  font-size: 11px;
  font-weight: var(--font-weight-medium);
  text-overflow: ellipsis;
  white-space: nowrap;
}
